// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G6tZ","largestCol":"styles_largestCol__1939Q","smallestCol":"styles_smallestCol__1byNe"};